export default "__VITE_ASSET__OFYlNJr6__"